export default __webpack_public_path__ + "static/media/icons8-hacksaw.94ec6fad.svg";